module.exports = __webpack_public_path__ + "static/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.ico
// module id = 907
// module chunks = 76